import cn from "classnames";
import isEqual from "lodash/isEqual";
import { Children, cloneElement } from "react";

import EmptyWidget from "@components/cms/EmptyWidget/EmptyWidget";
import { useStore } from "@hooks/useZustandProvider";
import Container from "@ui-kit/Container/Container";
import Loading from "@ui-kit/Loading/Loading";

import s from "./Block.module.scss";

function compareStructures(obj1, obj2, checkTypes) {
  // Проверка типов обоих объектов
  if (
    typeof obj1 !== "object" ||
    typeof obj2 !== "object" ||
    obj1 === null ||
    obj2 === null
  ) {
    return false;
  }

  // Получение ключей обоих объектов
  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  // Проверка на количество ключей
  if (keys1.length !== keys2.length) {
    return false;
  }

  // Сравнение ключей и структуры
  for (const key of keys1) {
    if (!keys2.includes(key)) {
      return false;
    }

    // Если checkTypes true, проверяем типы данных
    if (checkTypes && typeof obj1[key] !== typeof obj2[key]) {
      return false;
    }

    // Рекурсивный вызов для вложенных объектов
    if (
      typeof obj1[key] === "object" &&
      obj1[key] !== null &&
      typeof obj2[key] === "object" &&
      obj2[key] !== null
    ) {
      if (!compareStructures(obj1[key], obj2[key], checkTypes)) {
        return false;
      }
    }
  }

  return true;
}

const Block = ({
  children,
  index,
  // block: blockData, // { data, settings }
  block, // { data, settings }
  widgetId,
  blockTemplate,
  loading,
  updateField,
  toggleCollectionModal,
  ...props
}) => {
  const { initEmptyData, preview } = blockTemplate;
  const childrens = Children.toArray(children);

  const { cms, updateDataBlock, updateDataWidget, updateBlockIndex } =
    useStore();
  const { list, isWidgetEditing } = cms.widget;
  const { lang } = cms.page;
  const { isEditMode } = cms.uiOptions;

  // const blockLang = getBlockLocale(locale);

  // const updateField = (payload) => {
  //   isWidgetEditing
  //     ? updateDataWidget(payload)
  //     : updateDataBlock(payload, index);
  // };

  // useEffect(() => {
  //   compareStructures()
  //   setTimeout(() => {
  //     // structure updated
  //   }, 1000)
  // }, [blockTemplate.block.name])

  const blockType =
    block?.settings?.common?.blockType ||
    blockTemplate.block.settings?.common?.blockType;

  const isFullHeight = block?.settings?.common?.useWindowHeight?.value ?? false;

  const isEmptyWidget = isEqual(
    {
      data: block?.data,
    },
    {
      data: initEmptyData,
    },
  );

  if (widgetId && isEmptyWidget && !isEditMode) {
    return null;
  }

  if (widgetId && isEmptyWidget && !isWidgetEditing && isEditMode) {
    return (
      <Container>
        <Container full={false}>
          <div
            className={cn(
              s.block,
              s[blockType?.value],
              isFullHeight && s.fullHeight,
            )}
            {...props}
          >
            <EmptyWidget
              preview={preview}
              type={block.widgetType}
              lang={lang}
              widgetId={widgetId}
            />
          </div>
        </Container>
      </Container>
    );
  }

  return (widgetId && !list[widgetId] && isEditMode) ||
    (!isEditMode && loading) ||
    (!isEditMode && !block) ? (
    <div
      className={cn(s.block, s[blockType?.value], isFullHeight && s.fullHeight)}
      {...props}
    >
      <Loading />
    </div>
  ) : (
    <div
      onClick={(e) => {
        if (isEditMode) {
          e.stopPropagation();
          updateBlockIndex(index, !!widgetId);
        }
      }}
      className={cn(
        s.block,
        s[blockType?.value],
        isFullHeight && s.fullHeight,
        isWidgetEditing && s.isWidgetEditing,
      )}
      {...props}
    >
      {childrens.map((child, key) => {
        return cloneElement(child, {
          key,
          index,
          className: s.inner,
          updateField,
          toggleCollectionModal,
          ...block,
        });
      })}
    </div>
  );
};

export default Block;
